import { useQuery } from "@tanstack/react-query";
import { getPostCategories } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPostCategories = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["post-categories", params, i18next.language],
        queryFn: () => getPostCategories(params),
        keepPreviousData: true,
    });

    return {
        categories: data?.data || [],
        meta: data?.meta,
        isLoading,
        error,
        refetch,
    };
};
